import React, { useCallback, useEffect } from 'react'
import '../assets/css/style.css'
import info from '../assets/img/icon/info.svg'
import guide_1 from '../assets/img/torikuzushi_simulation/guide_1.svg'
import { Modal } from './Modal'

interface CalcReversalGuideModalProps {
  isShow: boolean
  setShow: React.Dispatch<React.SetStateAction<boolean>>
}

export const CalcReversalGuideModal: React.FC<CalcReversalGuideModalProps> = React.memo((props) => {
  const { isShow, setShow } = props
  useEffect(() => {
    if (isShow) {
      document.body.setAttribute('style', 'overflow: hidden;')
    } else {
      document.body.removeAttribute('style')
    }

    return () => document.body.removeAttribute('style')
  }, [isShow])

  const handleHide = useCallback(() => {
    setShow(false)
  }, [setShow])

  return (
    <React.Fragment>
      {isShow && (
        <Modal className="c-modal">
          <div className="c-modal__content">
            <div className="c-modal__head">
              <span className="c-modal__head__icon">
                <img src={info} alt="" />
              </span>
              <h2 className="c-modal__head__title">
                取り崩しシミュレーション
                <br className="spOnly" /> 使い方ガイド
              </h2>
              <span className="c-modal__head__close" onClick={handleHide}></span>
            </div>
            <div className="c-modal__body">
              <div className="c-modal__lead">
                <p>あなたの資産が何歳まで続くのかシミュレーションできます</p>
              </div>
              <h3 className="c-heading-1">操作方法</h3>
              <p>STEP１</p>
              <p className="u-mb1em">
                お客様が想定している保有資産、取り崩し開始年齢、取り崩し額、資産運用時のリターンを入力してください。
                <br />
                保有資産、取り崩し開始年齢、毎月の取り崩し額を変更することができます。
              </p>
              <p className="u-mb2em">
                ※取り崩し額を途中で変更する場合は「取り崩し年齢と取り崩し額を途中で変更する」をクリック（タップ）し、
                「取り崩し変更年齢」と「取り崩し変更額（毎月）」を入力してください。
              </p>

              <p className="u-mb1em">
                {/* eslint-disable-next-line no-irregular-whitespace */}
                STEP２　「計算」をクリック（タップ）してください。
              </p>
              <p className="u-mb1em">
                各項目の入力数値は以下の通りとなります。
                <br />
                入力値が下記表の範囲外の場合、エラーが表示されます。範囲内の数値を入力してください。
              </p>
              <table className="c-table">
                <tbody>
                  <tr>
                    <th>
                      保有資産<sup>*</sup>
                    </th>
                    <td>0～99999.9 万円</td>
                  </tr>
                </tbody>
              </table>
              <p className="u-mb1em">* 小数点一桁まで有効</p>
              <table className="c-table">
                <tbody>
                  <tr>
                    <th colSpan={2}>取り崩し設定</th>
                  </tr>
                  <tr>
                    <th>開始年齢</th>
                    <td>0～99 歳</td>
                  </tr>
                  <tr>
                    <th>
                      取り崩し額（毎月）<sup>*</sup>
                    </th>
                    <td>0～999.9 万円</td>
                  </tr>
                  <tr>
                    <th>取り崩し変更年齢</th>
                    <td>開始年齢 &lt; 99 歳</td>
                  </tr>
                  <tr>
                    <th>
                      取り崩し変更額（毎月）<sup>*</sup>
                    </th>
                    <td>0～999.9 万円</td>
                  </tr>
                </tbody>
              </table>
              <p className="u-mb1em">* 小数点一桁まで有効</p>
              <table className="c-table">
                <tbody>
                  <tr>
                    <th colSpan={2}>運用した場合のリターン（年率）</th>
                  </tr>
                  <tr>
                    <th>
                      パターン１<sup>*</sup>
                    </th>
                    <td>0～99.9 ％</td>
                  </tr>
                  <tr>
                    <th>
                      パターン２<sup>*</sup>
                    </th>
                    <td>0～99.9 ％</td>
                  </tr>
                </tbody>
              </table>
              <p className="u-mb1em">* 小数点一桁まで有効</p>
              <p>評価額の上限は、999,999万円となります。</p>

              <h3 className="c-heading-1">シミュレーションの計算方法</h3>
              <p>以下の式より残高(X)を求めます。</p>
              <p>
                <img alt="シミュレーションの計算方法" src={guide_1} style={{ height: '350px' }} />
              </p>

              <h3 className="c-heading-1">用語説明</h3>
              <h4>参考情報</h4>
              <dl className="c-modal__d-list">
                <dt>リターン</dt>
                <dd>
                  リターンとは、投資収益率のことで、3年、5年など、決められた2つの時点の価格（指数値）を比較して、何％上昇したか（あるいは下落したか）を表す指標のことです。
                </dd>
              </dl>
              <dl className="c-modal__d-list">
                <dt>リスク</dt>
                <dd>
                  リスクとは、リターン（投資収益率）のぶれを意味します。
                  高いリターンを求めるのであれば高いリスクを許容する必要があり、
                  リスクをとりたくないのであれば低いリターンを享受すべきであるとされます。
                </dd>
              </dl>
            </div>
          </div>
          <div className="c-modal__overlay" onClick={handleHide}></div>
        </Modal>
      )}
    </React.Fragment>
  )
})
